import { cloneDeep } from 'lodash';
import { focusNextInput, focusPreviousInput } from './utils.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@elliemae/ds-utilities/timeUtils';
import '@elliemae/ds-utilities/utils';
import 'moment';

var callChange = function callChange(event, handlers, isArrowChange) {
  if (event.target.name === 'day') handlers.onDayChange(event, isArrowChange);
  if (event.target.name === 'month') handlers.onMonthChange(event, isArrowChange);
  if (event.target.name === 'year') handlers.onYearChange(event, isArrowChange);
};

var setTarget = function setTarget(event, v) {
  var n = cloneDeep(event);
  var newValue = parseInt(n.target.value || 0, 10) + v;
  if (newValue < 1) newValue = '01';
  if (event.target.name === 'day' && newValue > 31) newValue = 31;
  if (event.target.name === 'month' && newValue > 12) newValue = 12;
  n.target.value = newValue;
  return n;
}; // eslint-disable-next-line max-statements, complexity


var onKeyDownHelper = function onKeyDownHelper(event, handlers) {
  switch (event.key) {
    case 'ArrowLeft':
      {
        event.preventDefault();
        focusPreviousInput(event.target);
        break;
      }

    case 'ArrowUp':
      {
        event.preventDefault();
        var n = setTarget(event, 1);
        callChange(n, handlers, true);
        break;
      }

    case 'ArrowDown':
      {
        event.preventDefault();

        var _n = setTarget(event, -1);

        callChange(_n, handlers, true);
        break;
      }

    case 'ArrowRight':
      {
        event.preventDefault();
        focusNextInput(event.target);
        break;
      }

    case 'Tab':
      {
        if (event.shiftKey) break;
        if (event.target.value.length > 0 && event.target.name !== 'year') event.preventDefault();
        callChange(event, handlers);
        break;
      }

    case 'Backspace':
      {
        // HTML Date input behavior, clear everything when deleting
        event.preventDefault();

        var _n2 = cloneDeep(event);

        _n2.target.value = '';
        callChange(_n2, handlers, true);
        break;
      }
  }
};

export { onKeyDownHelper };
//# sourceMappingURL=helpers.js.map
